import React from "react";
import { IconBed, IconBath, IconWifi, IconSparkle, IconPin, IconHome } from "./Icons";

const SERVICES = [
  {
    icon: IconBed,
    title: "3 bedrooms",
    text: "Comfortable accommodation for up to six guests — ideal for families or friends travelling together.",
  },
  {
    icon: IconBath,
    title: "2.5 bathrooms",
    text: "Modern fittings and generous showers, including a private bathroom for the main bedroom.",
  },
  {
    icon: IconSparkle,
    title: "Fully equipped kitchen",
    text: "Oven, microwave, dishwasher, fridge, coffee makers and a water refill station.",
  },
  {
    icon: IconWifi,
    title: "Fast Wi-Fi",
    text: "Reliable connection throughout the house — good enough to work remotely or stream.",
  },
  {
    icon: IconPin,
    title: "Prime location",
    text: "Two minimarkets, bus stops to Sorrento and Amalfi, and a short walk to Spiaggia Grande.",
  },
  {
    icon: IconHome,
    title: "A dedicated host",
    text: "Personal recommendations and help arranging transfers, boats and restaurants.",
  },
];

export const Services = ({ airbnbUrl }) => (
  <section className="section section--sand" id="services">
    <div className="container">
      <div className="section-head">
        <span className="eyebrow">Amenities</span>
        <h2>Everything you need</h2>
        <hr className="rule" />
        <p>
          Air conditioning, heating, a washing machine, smart TVs and thoughtful extras — all
          included.
        </p>
      </div>

      <div className="services__grid">
        {SERVICES.map(({ icon: Icon, title, text }) => (
          <article className="service" key={title}>
            <div className="service__icon">
              <Icon width={24} height={24} />
            </div>
            <h3>{title}</h3>
            <p>{text}</p>
          </article>
        ))}
      </div>

      {airbnbUrl && (
        <p className="services__note">
          See the full amenity list on{" "}
          <a href={`${airbnbUrl}/amenities`} target="_blank" rel="noopener noreferrer">
            Airbnb
          </a>
          .
        </p>
      )}
    </div>
  </section>
);

export default Services;
